module.exports = __webpack_public_path__ + "media/packs/images/lens-48475f15c5492a8f77d0610d15624e77.svg";